import accountApi from './http/account'
import clientApi from './http/client'
import supportApi from './http/support'
import userApi from './http/user'

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL

export default {
  // auth
  register: (data: any) => userApi.post('/auth/register', data),
  verifyEmail: (email: string, otp: string) => userApi.post('/auth/verify-email', { email, otp }),
  sendVerifyEmail: (email: string) => userApi.post('/auth/send-verify-email', { email }),
  login: (email: string, password: string) => userApi.post('/auth/login', { email, password }),
  changePassword: (data: Record<string, string>) => userApi.post('/auth/change-password', data),
  forgotPassword: (email: string) => userApi.post('/auth/forgot-password', { email }),
  verifyOtp: (data: Record<string, any>) => userApi.post('/auth/otp-check', data),
  resetPassword: (data: Record<string, any>) => userApi.post('/auth/password-reset', data),

  // users
  getMyInfo: () => userApi.get('/my-info'),
  getMyNotice: () => userApi.get('/my-notice'),
  markAsRead: (id: number) => userApi.patch(`/notice/${id}/mark-as-read`),
  noticeDismiss: (id: number) => userApi.patch(`/notice/${id}/dismiss`),

  // Dashboard
  getOrderReport: () => clientApi.get('/my-order-report'),
  getInvoiceReport: () => accountApi.get('/my-invoice-report'),
  getTicketReport: () => supportApi.get('/my-ticket-report'),

  // services
  services: ({
    perPage,
    payment_step,
    search,
    page,
  }: {
    perPage: number
    payment_step: number
    search: string
    page: number
  }) => clientApi.get(`/services?paginate=${perPage}&payment_step=${payment_step}&search=${search}&page=${page}`),
  createServiceOrder: (payload: { service_id: number; order_information: string | null }) =>
    clientApi.post('/servicesorders', payload),

  // orders
  orders: ({
    perPage,
    search,
    page,
    paymentStatus,
    status,
    paymentFrequency,
    serviceOrderStartDate,
    serviceOrderEndDate,
  }: {
    perPage: number
    search: string
    page: number
    paymentStatus?: string
    status?: string
    paymentFrequency?: string
    serviceOrderStartDate?: string
    serviceOrderEndDate?: string
  }) =>
    clientApi.get(
      `/myservicesorders?paginate=${perPage}&page=${page}&search=${search}&paymentStatus=${
        paymentStatus || ''
      }&status=${status || ''}&paymentFrequency=${paymentFrequency || ''}&serviceOrderStartDate=${
        serviceOrderStartDate || ''
      }&serviceOrderEndDate=${serviceOrderEndDate || ''}`,
    ),

  // invoices
  invoices: ({
    search,
    page,
    perPage,
    status,
    invoiceStartDate,
    invoiceEndDate,
  }: {
    search: string
    page: number
    perPage: number
    status: string
    invoiceStartDate: string
    invoiceEndDate: string
  }) =>
    accountApi.get(
      `/my-invoice?invoiceSearch=${search}&page=${page}&per_page=${perPage}&status=${status}&invoiceStartDate=${invoiceStartDate}&invoiceEndDate=${invoiceEndDate}`,
    ),

  // support tickets
  tickets: ({ search, status, page, perPage }: { search: string; status: string; page: number; perPage: number }) =>
    supportApi.get(`/myticket?search=${search}&status=${status}&page=${page}&per_page=${perPage}`),
  createTicket: (payload: FormData | { subject: string; description: string; files: File[] }) =>
    supportApi.post('/tickets', payload),
  openTicket: (id: string) => supportApi.get(`/tickets/${id}/open`),
  replyTicket: (payload: FormData) => supportApi.post(`tickets/reply`, payload),

  // payments
  payments: ({search, page, perPage}: {search: string; page: number; perPage: number}) => accountApi.get(`/my-payments?search=${search}&page=${page}&per_page=${perPage}`),
}
